module.exports = __webpack_public_path__ + "img/modal5.be8b9bdc.png";